import Box from '@mui/material/Box'

import { optimizedImagePath } from '@/utills'

/**
 * Component for the main display of Interactive Map/Checkout game component (of which there are two at time of writing)
 * @param backgroundImageProperty - The background image CSS property
 * @param isActive - Whether the image should be displayed or not
 */
const InteractiveGameDisplay = ({
    backgroundImageProperty,
    isActive,
}: {
    backgroundImageProperty: string
    isActive: boolean
}) => {
    return (
        <Box
            className={isActive ? 'active' : ''}
            sx={{
                backgroundImage: `url(${optimizedImagePath({
                    rawUrl: backgroundImageProperty,
                    width: 1584,
                })})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
                opacity: 0,
                zIndex: -1,
                transition: 'all .3s ease-in-out',
                '&.active': {
                    opacity: 1,
                    zIndex: 0,
                },
            }}
        />
    )
}

export default InteractiveGameDisplay
